/**
* Class SaveWndUI
*/
export default class SaveWndUI {
  /* Конструктор */
  constructor() {
    this.id = 'MapSaveWnd'
    this.window_title = 'Сохранить зону'
    return this.ui()
  }

  /* Форма в окне */
  form() {
    return {
      type: 'clean',
      rows: [
        {
          id: `${this.id}Form`,
          view: 'form',
          elementsConfig: {
            labelAlign: 'left',
            inputAlign: 'left'
          },
          elements: [
            {
              margin: 4,
              rows: [
                {
                  cols: [
                    {
                      view: 'text',
                      id: `${this.id}Name`,
                      label: 'Название зоны',
                      width: 567,
                      labelWidth: 100
                    }
                  ]
                },
                {
                  cols: [
                    {
                      view: 'textarea',
                      id: `${this.id}Notes`,
                      label: 'Описание',
                      width: 567,
                      labelWidth: 100
                    }
                  ]
                },
                {
                  cols: [
                    {},
                    {
                      view: 'button',
                      id: `${this.id}BtnSave`,
                      label: 'Сохранить',
                      width: 120,
                      css: 'btnGreen'
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  }

  /* Окно */
  ui() {
    return {
      id: this.id,
      view: 'window',
      fullscreen: false,
      move: false,
      position: 'center',
      width: 600,
      modal: true,
      head: {
        view: 'toolbar',
        cols: [
          {
            view: 'button',
            id: `${this.id}BtnClose`,
            label: 'Закрыть',
            width: 100,
            align: 'left'
          },
          {
            view: 'label',
            id: `${this.id}Label`,
            label: this.window_title
          }
        ]
      },
      body: this.form()
    }
  }
}
